<template>
    <div>
        <PageHeader title="经销商扫码明细" hidden-breadcrumb>
            <div slot="back" @click="jumpPrevPage"><Icon type="md-arrow-back" /></div>
            <Button
                slot="action"
                type="info"
                class="ivu-ml"
                icon="md-cloud-download"
                @click="onExport"
                :loading="isExporting"
                >{{ isExporting ? '正在导出...' : '导出' }}</Button
            >
        </PageHeader>
        <Card dis-hover class="ivu-mt">
            <table-form :formList="formList" @on-submit="onSubmit" ref="table-form" />
            <table-page @onPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" :list="list" />
        </Card>
    </div>
</template>

<script>
import tablePage from '@/components/tablePage';
import tableForm from '@/components/tableForm';
import { MonthDeatail, ExportDetail } from '@/api/statistics';
import { jumpPage, transPathToName } from '@/libs/util';

export default {
    name: 'statistics-rebate-detail',
    components: {
        tableForm,
        tablePage,
    },
    data() {
        return {
            isExporting: false,
            date: this.$route.query.date,
            fatherPath: this.$route.query.fatherPath,
            title: '扫码记录',
            showModal: false,
            formList: [
                {
                    title: '商品名称',
                    type: 'input',
                    key: 'tiresName',
                    placeholder: '模糊搜索',
                },
                {
                    title: '胎号',
                    type: 'input',
                    key: 'tyrecode',
                    placeholder: '模糊搜索',
                },
                {
                    title: '条码',
                    type: 'input',
                    key: 'barcode',
                    placeholder: '模糊搜索',
                },
                {
                    title: '扫码类型',
                    type: 'select',
                    key: 'scanCodeType',
                    placeholder: '请选择',
                    clearable: true,
                    options: [
                        { id: '', name: '全部' },
                        { id: 52, name: '出库' },
                        { id: 53, name: '退货' },
                    ],
                },
            ],
            list: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                loading: false,
                isChangePage: false,
                columns: [
                    { title: '商品名称', key: 'productName', minWidth: 300, fixed: 'left' },
                    { title: '胎号', key: 'tyrecode', minWidth: 170 },
                    { title: '条码', key: 'barcode', minWidth: 200 },
                    { title: '扫码类型  ', key: 'scancodeType', minWidth: 150 },
                    {
                        title: '状态',
                        key: 'status',
                        width: '80',
                        render: (h, p) => {
                            let badge = h('Badge', {
                                props: {
                                    status: p.row.status ? 'success' : 'error',
                                    text: p.row?.status ? '正常' : '异常',
                                },
                            });
                            return h('div', [badge]);
                        },
                    },
                    { title: '扫码时间', key: 'createDate', minWidth: 250 },
                    { title: '备注', key: 'abnormalValue', minWidth: 180 },
                ],
                data: [],
            },
            listRecord: {
                loading: false,
                columns: [
                    { title: '订单号', key: 'sn', minWidth: 220, fixed: 'left' },
                    { title: '经销商/门店', key: 'scanCodeDate', minWidth: 170 },
                    { title: '时间', key: 'scanCodeTypeMeaning', minWidth: 200 },
                    { title: '扫码类型  ', key: 'totalItemQuantity', minWidth: 100 },
                    { title: '备注', key: 'scanCodeOperateName', minWidth: 250 },
                ],
                data: [],
            },
        };
    },
    mounted() {
        this.getData();
    },

    methods: {
        getData(p) {
            this.list.loading = true;
            const param = {
                current: this.list.current,
                size: this.list.size,
                date: this.date,
                ...p,
            };
            MonthDeatail(param)
                .then((res) => {
                    this.list.loading = false;
                    this.list.total = Number(res.total);
                    this.list.data = res.records || [];
                })
                .catch(() => {
                    this.list.loading = false;
                });
        },
        onSubmit(param) {
            this.list.current = 1;
            this.getData(param);
        },
        onPageChange(val) {
            this.list.current = val;
            let form = this.$refs['table-form'].getFormData();
            this.getData(form);
        },
        onPageSizeChange(val) {
            this.list.current = 1;
            this.list.size = val;
            let form = this.$refs['table-form'].getFormData();
            this.getData(form);
        },
        seeRecord() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        jumpPrevPage() {
            window.$basePageStore.closeTab(transPathToName(location.pathname));
            jumpPage({ path: this.fatherPath });
        },
        onExport() {
            this.list.loading = true;
            this.isExporting = true;
            let form = this.$refs['table-form'].getFormData();
            if (!form.date) {
                form.date = this.date;
            }
            let params = {
                current: this.list.current,
                size: this.list.size,
                ...form,
            };
            ExportDetail(params)
                .then(() => {
                    this.list.loading = false;
                    this.isExporting = false;
                    this.$Message.destroy();
                    this.$Modal.confirm({
                        title: '提示',
                        content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                        onOk: () => {
                            console.log('export');
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                    this.$Notice.error({
                        title: '导出失败 ！',
                    });
                    this.list.loading = false;
                    this.isExporting = false;
                });
        },
    },
};
</script>

<style scoped></style>
